var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTripinline = function SvgTripinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 322,
    height: 55,
    fill: "none",
    viewBox: "0 0 322 79"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7993",
    d: "M123.044 18.847a15.425 15.425 0 0 0-11.767 5.501v-3.54H99.485v57.57h13.107V58.214a16.263 16.263 0 0 0 10.452 3.803 21.262 21.262 0 0 0 20.951-21.526 21.259 21.259 0 0 0-20.951-21.525m20.951 21.525a21.259 21.259 0 0 0-20.951-21.525m-1.292 31.092a9.567 9.567 0 1 1 9.161-9.567 9.366 9.366 0 0 1-.631 3.601 9.365 9.365 0 0 1-4.96 5.18 9.344 9.344 0 0 1-3.57.786M165.592 54.173a7.872 7.872 0 0 1-4.841 7.287 7.868 7.868 0 1 1-3.028-15.132 7.85 7.85 0 0 1 7.27 4.837c.395.954.599 1.976.599 3.008"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7993",
    fillRule: "evenodd",
    d: "M83.747 15.308a7.341 7.341 0 0 1-5.224-12.526 7.342 7.342 0 0 1 12.543 5.183 7.32 7.32 0 0 1-7.319 7.343",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7993",
    d: "M90.326 20.809H77.243V60.08h13.083V20.809"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7993",
    fillRule: "evenodd",
    d: "M.037 2.488v10.978h17.005v46.591H30.15v-46.59h17.005V2.487H.037Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7993",
    d: "M193.073 49.988a9.565 9.565 0 0 1-6.764-16.332 9.565 9.565 0 0 1 6.764-2.802 8.94 8.94 0 0 1 6.602 2.942l8.658-8.658a21.525 21.525 0 1 0 0 30.542l-8.658-8.634a9.04 9.04 0 0 1-6.602 2.942"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7993",
    fillRule: "evenodd",
    d: "M307.613 18.824a13.225 13.225 0 0 0-12.198 6.433 13.062 13.062 0 0 0-11.72-6.433 12.773 12.773 0 0 0-11.456 6.433V20.81h-11.767v39.248h13.082V35.566a5.78 5.78 0 0 1 1.548-4.314 5.763 5.763 0 0 1 9.957 4.314v24.491h12.317V35.566a5.763 5.763 0 1 1 11.504 0v24.491h13.083V33.102c0-8.85-5.549-14.35-14.35-14.35",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7993",
    d: "M232.322 18.847a21.527 21.527 0 1 0 0 43.053 21.527 21.527 0 0 0 0-43.053m0 31.093a9.568 9.568 0 1 1 9.161-9.567 9.379 9.379 0 0 1-9.161 9.567M68.081 20.593a14.016 14.016 0 0 0-11.767 6.362V20.81H44.523v39.248h13.154v-16.36A10.546 10.546 0 0 1 68.655 32.72c.69.012 1.379.084 2.057.216V20.976a18.89 18.89 0 0 0-2.631-.215"
  })));
};
export default SvgTripinline;